import React, { createContext, useContext } from 'react';
import { stateKeys, useCropperState } from '../../model';

const ErrMsgsStateContext = createContext();

export const useErrMsgsState = () => useContext(ErrMsgsStateContext);

const Provider = ({ children }) => {
  const { [stateKeys.errMsgs]: errMsgs } = useCropperState();

  return (
    <ErrMsgsStateContext.Provider value={errMsgs}>
      {children}
    </ErrMsgsStateContext.Provider>
  );
};

export default Provider;
